























import Vue from "vue";
import AppFooter from "./components/AppFooter.vue";
import AppHeader from "./components/AppHeader.vue";

document.title = 'Home Works'

export default Vue.extend({
  name: "App",
  data: () => ({
    accessToken: sessionStorage.getItem("accessToken"),
  }),
  components: {
    AppHeader,
    AppFooter
  },
  created() {
      !this.accessToken ? this.$router.push('/login') : null;
    },
});
